import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m9.779 3.25-.719 1.5H3.053c-.176 0-.303.12-.303.25v10.252l3.997-3.796a.75.75 0 0 1 .97-.053l2.082 1.582.623-.69 3.294 4.744-.967 3.71-9.696.001c-.988 0-1.803-.775-1.803-1.75V5c0-.975.815-1.75 1.803-1.75zm11.168 0c.988 0 1.803.775 1.803 1.75v14c0 .927-.736 1.672-1.656 1.744l-.147.006h-6.12L16 17.04l-4.265-6.2.76-.842a.75.75 0 0 1 .998-.105l7.757 5.635V5c0-.13-.127-.25-.303-.25H10.881l.868-1.5zM7 6.75c.356 0 .686.118.948.318l-.557 1.16.98.705A1.55 1.55 0 0 1 7 9.75c-.842 0-1.54-.663-1.54-1.5s.698-1.5 1.54-1.5"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }